module.exports = __webpack_public_path__ + "img/shopping_application_5-2.2e4f39f7.jpg";